<panel width="400">
  @if (loading) {
    <h1><skeleton /></h1>
    <skeletons [defaultSkeletons]="4" />
  }
  @if (!loading) {
    <h1>{{ (variantList && variantList.id ? 'product.edit-variant-list' : 'product.create-variant-list') | translate }}</h1>
    <section>
      <custom-input [label]="'product.variant-list.name' | translate" [inputType]="inputTypeEnum.Text" [(value)]="variantList.name" [required]="true" />
      @if (variantList.id == undefined) {
        <custom-select [label]="'product.variant-list.type' | translate" [selectList]="variantListTypes" [(value)]="variantList.type" [required]="variantList.id == undefined" />
      }
    </section>
    <scrollable>
      <section>
        @for (option of variantList.variantListOptions; track option; let i = $index) {
          <div>
            @if (!option.id) {
              <custom-input [label]="'product.variant-list.option' | translate: { index: i+1 }" [inputType]="variantList.type == variantListTypesEnum.Period ? inputTypeEnum.Number : inputTypeEnum.Text" [(value)]="option.name" [required]="true" />
            }
            @if (option.id) {
              {{ option.name }}
            }
          </div>
          <div>
            <icon small type="trash" (click)="removeOptionValue(i)" />
          </div>
        }
      </section>
      <section>
        <button small (click)="addOptionValue()" [loader]="false" [ignoreValidation]="true"><icon type="plus" /></button>
      </section>
    </scrollable>
    <section>
      <button #saveButton confirm (click)="saveVariantList()">{{ 'general.save' | translate }}</button>
    </section>
  }
</panel>
